import { useMemo } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import { ShippingMethod } from 'types/entity/cart';
import { Order } from 'types/entity/order';

type UseOrderDataProps = {
  order?: Order;
  shippingMethods: ShippingMethod[];
};

const useOrderData = ({ order, shippingMethods }: UseOrderDataProps) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const shippingInfo = useMemo(
    () =>
      shippingMethods.find(
        (shippingMethod: ShippingMethod) => shippingMethod.shippingMethodId === order?.shippingInfo?.shippingMethodId,
      )?.name ??
      (order?.custom?.fields?.shippyProPickupPointId
        ? formatMessage({ id: 'shipping.pickupPoint', defaultMessage: 'Punto di ritiro' })
        : ''),
    [order, shippingMethods, formatMessage],
  );

  return {
    shippingInfo,
  };
};
export default useOrderData;
